// Shared base style for all floating handles to keep them invisible
const base = {
  opacity: 0,
};

// Vertical offsets (top target goes up; bottom source goes down)
const topOffset = 'translateY(calc(-1 * var(--GDS-space-quarter)))';
const bottomOffset = 'translateY(var(--GDS-space-quarter))';

// Horizontal offsets for decision node branch handles
const decisionTrueX = 'translateX(-40px)';
const decisionFalseX = 'translateX(40px)';

export const floatingHandleStyles = {
  targetTop: { ...base, transform: topOffset },
  sourceBottom: { ...base, transform: bottomOffset },
  decisionTrue: { ...base, transform: `${decisionTrueX} ${bottomOffset}` },
  decisionFalse: { ...base, transform: `${decisionFalseX} ${bottomOffset}` },
} as const;

export type FloatingHandleStyleKey = keyof typeof floatingHandleStyles;
